import anime from 'animejs';

// slide in/out components
// as user scroll to them
const slideInOut = e => {
  const windowHeight = window.innerHeight;
  const threshold = 0.9;
  const components = document.querySelectorAll('main > section');
  const filterComponents = [...components].filter(el => {
    if (!el.classList.contains('v-hp-hero') && !el.classList.contains('v-hero') && !el.classList.contains('v-form')) {
      return el;
    }
  });

  [...filterComponents].forEach(el => {
    if (el.getBoundingClientRect().top - windowHeight * threshold < 0) {
      anime({
        targets: el,
        translateY: 0,
        duration: 750,
        easing: 'easeOutCirc'
      });

    } else {
        anime({
          targets: el,
          translateY: 150,
          duration: 750,
          easing: 'easeOutCirc'
        });
    }
  });
};
slideInOut();
window.addEventListener('scroll', slideInOut);

export default slideInOut;